import './Counter.scss'

const DateTimeDisplay = ({ text, value, ariaLabel }) => (
  <div>
    <p className="counter__display-value">{value}</p>
    <p className="counter__display-text" aria-label={ariaLabel}>
      {text}
    </p>
  </div>
)

const Counter = ({ days, hours, minutes, seconds, separator }) => (
  <div className="counter">
    <DateTimeDisplay value={days} text={'Dias'} ariaLabel="Dias" />
    <span aria-hidden="true" className="counter__separator">
      {separator}
    </span>
    <DateTimeDisplay value={hours} text={'Hrs'} ariaLabel="Horas" />
    <span aria-hidden="true" className="counter__separator">
      {separator}
    </span>
    <DateTimeDisplay value={minutes} text={'Min'} ariaLabel="Minutos" />
    <span aria-hidden="true" className="counter__separator">
      {separator}
    </span>
    <DateTimeDisplay value={seconds} text={'Seg'} ariaLabel="Segundos" />
  </div>
)

export default Counter
